<template>
  <date-picker
    v-bind="$attrs"
    :default-value="initValue"
    :clearable="clearable"
    :disabled="disabled"
    input-class="form-input col spectre"
    :bootstrap-styling="true"
    :placeholder="$attrs.placeholder || $t('appointments.detail.select-day')"
    format="DD/MM/YYYY"
    @input="onInput"
    v-model="valueAsDate"
    :disabled-days="disableSundays"
    :disabled-date="isDateDisabled"
    :lang="{
      formatLocale: {
        firstDayOfWeek: 1,
        weekdaysMin: this.locale === 'pt' ? ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'] : ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      },
    }" />
</template>
<script>
import 'vue2-datepicker/index.css'

import moment from 'moment'
import DatePicker from 'vue2-datepicker'

import {mapGetters} from '@/utils/map-store'

export default {
  components: {DatePicker},
  props: {
    value: String,
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    notBefore: Date,
    notAfter: Date,
    initValue: Date,
  },
  computed: {
    valueAsDate: {
      get() {
        return moment.utc(this.value).toDate()
      },
      set(val) {
        const newValue = moment(val).format('YYYY-MM-DD')
        this.$emit('input', newValue)
      },
    },
    ...mapGetters({
      group: 'getGroup',
    }),
    locale() {
      return this.$store.getters.getLocale.split('-')[0]
    },
  },
  mounted() {
    if (this.locale === 'pt') {
      import('vue2-datepicker/locale/pt-br')
    } else {
      import('vue2-datepicker/locale/es')
    }
  },
  methods: {
    onInput(value) {
      // You can conditionally do this after validation
      const day = moment(value).startOf('day').format('YYYY-MM-DD')
      this.$emit('input', day)
    },
    disableSundays(date) {
      return moment(date).day() === 0
    },
    isDateDisabled(date) {
      const isBefore = this.notBefore ? moment(date) < moment(this.notBefore) : false
      const isAfter = this.notAfter ? moment(date) > moment(this.notAfter) : false
      return isBefore || isAfter
    },
  },
}
</script>
